import React from 'react'
import {withStyles} from 'external/material'
import MuiButton from '@mui/material/Button'

const Button = withStyles({
  root: {
    boxShadow: 'none',
    border: 'solid 1px #d6dbdf',
    backgroundColor: '#fff',
    height: 25,
    "&.cancel": {
      border: 'solid 1px #1d9be5',
      backgroundColor: '#1d9be5',
      color: '#fff'
    },
    borderRadius: 2,
    color: '#68728b',
    '& svg': {
      marginTop: -3
    },
    '&:hover': {
      backgroundColor: '#c7dcef',
      boxShadow: 'none',
    },
  },
  label: {
    textTransform: 'none'
  }
})(MuiButton)

export {Button as default}
